import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // No background polling — realtime data flows through WebSocket.
      refetchOnWindowFocus: false,
      refetchInterval: false,
      staleTime: 30_000,
      retry: (failureCount, error: unknown) => {
        // Do not retry on 401/403 — they need re-auth, not a retry storm.
        const status = (error as { status?: number } | null)?.status;
        if (status === 401 || status === 403) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
